import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CheckBox, Quicklink, TextAction } from '@node-space/storybook-components'
import { Box, Callout, Text } from '@node-space/ui-components'
import { BVNK_BLOG_FRAUD_PREVENTION } from 'constants/General'

interface BankDetailsConfirmationCallout {
  onDetailsConfirmationChange: (isChecked: boolean) => void
}

export const BankDetailsConfirmationCallout = ({
  onDetailsConfirmationChange,
}: BankDetailsConfirmationCallout) => {
  const { t } = useTranslation()
  const [isChecked, setIsChecked] = useState(false)

  const handleOnChange = (isChecked: boolean) => {
    setIsChecked(isChecked)
    onDetailsConfirmationChange(isChecked)
  }

  return (
    <>
      <Callout variant="info">
        <Text className="mb-2">{t('authorisedPushPaymentsMessage')}</Text>
        <TextAction
          text={t('howToPaySafelyMessage')}
          linkTo={BVNK_BLOG_FRAUD_PREVENTION}
          className="text-secondary-500 hover:underline hover:text-secondary-700 active:text-secondary-900"
        />
      </Callout>
      <Box paddingT={24} paddingB={8}>
        <CheckBox
          testid="app-checkbox"
          value={isChecked}
          onChange={(value: boolean) => handleOnChange(value)}
          labelComponent={
            <Box flex gap={8}>
              <Text className="whitespace-nowrap">
                {`${t('authorisedPushPaymentsConfirmationMessage')} `}
              </Text>
              <Quicklink
                className="whitespace-nowrap"
                text={t('learnMore')}
                to={BVNK_BLOG_FRAUD_PREVENTION}
              />
            </Box>
          }
        />
      </Box>
    </>
  )
}
